import axios from 'axios';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};
export async function get(url, params) {
  try {
    if (!url) {
      throw new Error('input url not found!');
    }
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    headers.Authorization = `${userInfo.token_type} ${userInfo.access_token}`;
    let data;
    if (params && params.token) {
      headers.Authorization = params.token;
    }
    if (params) {
      data = params.body;
    }
    let responseType;
    if (params && params.responseType) {
      responseType = params.responseType;
    }
    let _params = {
      method: 'get',
      url: `${window.configs.URL}/${url}`,
      headers,
      withCredentials: true,
      data,
      responseType,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

export async function post(url, params) {
  try {
    if (!url) {
      throw new Error('input url not found!');
    }
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    headers.Authorization = `${userInfo.token_type} ${userInfo.access_token}`;
    let data;
    if (params && params.token) {
      headers.Authorization = params.token;
    }
    if (params) {
      data = params.body;
    }
    let _params = {
      method: 'post',
      url: `${window.configs.URL}/${url}`,
      headers,
      withCredentials: true,
      data: data,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

export async function put(url, params) {
  try {
    if (!url) {
      throw new Error('input url not found!');
    }
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    headers.Authorization = `${userInfo.token_type} ${userInfo.access_token}`;
    let data;
    if (params && params.token) {
      headers.Authorization = params.token;
    }
    if (params) {
      data = params.body;
    }
    let _params = {
      method: 'put',
      url: `${window.configs.URL}/${url}`,
      headers,
      withCredentials: true,
      data,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

export async function _delete(url, params) {
  try {
    if (!url) {
      throw new Error('input url not found!');
    }
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    headers.Authorization = `${userInfo.token_type} ${userInfo.access_token}`;
    let data;
    if (params && params.token) {
      headers.Authorization = params.token;
    }
    if (params) {
      data = params.body;
    }
    let _params = {
      method: 'delete',
      url: `${window.configs.URL}/${url}`,
      headers,
      withCredentials: true,
      data,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

export async function loginRequest({ username, password }) {
  try {
    const formData = new FormData();
    formData.set('username', username);
    formData.set('password', password);
    formData.set('grant_type', window.configs.grant_type);
    formData.set('client_id', window.configs.client_id);
    formData.set('client_secret', window.configs.client_secret);
    headers.__tenant = window.configs.__tenant;
    let _params = {
      method: 'post',
      url: window.configs.LOGIN_URL,
      headers,
      withCredentials: true,
      data: formData,
    };
    return await _results(_params);
  } catch (error) {
    throw error;
  }
}

async function _results(params) {
  try {
    const resp = await axios(params);
    if (resp.status === 200 || resp.status === 201 || resp.status === 204) {
      if (resp.data.error) throw resp.data.message;
      if (params.responseType) {
        return resp;
      }
      return resp.data;
    }
    throw new Error(`${resp.statusText}`);
  } catch (error) {
    throw error;
  }
}
